import ProfileSetting from '@/Component/Profile/ProfileSetting'
import BankAccount from '@/Component/Profile/ProfileSetting/BankAccount'

const BankAccountPage = () => {
    return (
        <ProfileSetting activeTab="bank-account">
            <BankAccount />
        </ProfileSetting>
    )
}

export default BankAccountPage
